<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @reload="reload"
      @openEditDialog="openEditDialog"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @openEditDialog="openEditDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <EditFromDialog
      :title="editDialogOptions.title"
      :visible.sync="editDialogOptions.visible"
      :shipmentCustomerAddressCode="editDialogOptions.code"
      :disabled="editDialogOptions.disabled"
      :shipmentCustomerCode="shipmentCustomerCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditFromDialog from '../customer-address-edit-form/index.vue'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, EditFromDialog },
  props: {
    disabled: { type: Boolean, default: false },
    shipmentCustomerCode: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      editDialogOptions: {
        title: '',
        visible: false,
        code: '',
        disabled: false,
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shipmentCustomerAddressListApi({
          shipmentCustomerCode: this.shipmentCustomerCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, data }) {
      const { shipmentCustomerAddressCode: code } = data || {}
      const types = {
        edit:
          this.$l('dialog_title_customer_address_edit') ||
          '编辑收发货人相关地址信息',
        add:
          this.$l('dialog_title_customer_address_add') ||
          '新增收发货人相关地址信息',
        detail:
          this.$l('dialog_title_customer_address_detail') ||
          '收发货人相关地址信息详情',
      }
      this.editDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
  },
}
</script>
